/* MOONAS MAGICKA — brand system: icons and cubit sigils (the logo itself is Steven's original emblem, img/logo.png).
   Icons are drawn on a 24-unit grid with a 1.25 stroke so they read as one family. */
(function () {
  const NS = 'http://www.w3.org/2000/svg';

  // Icon set — each object drawn from the actual forms Steven makes.
  const I = {
    ring: '<circle cx="12" cy="12" r="7.5"/><path d="M12 4.5c1.6 1.2 1.6 2.4 0 3.6M19.5 12c-1.2 1.6-2.4 1.6-3.6 0M12 19.5c-1.6-1.2-1.6-2.4 0-3.6M4.5 12c1.2-1.6 2.4-1.6 3.6 0"/>',
    harmonizer: '<circle cx="12" cy="11" r="7.5"/><ellipse cx="12" cy="11" rx="3.2" ry="7.5"/><path d="M4.5 11h15M8 21h8M12 18.5V21"/>',
    pendant: '<path d="M7 3.5c1.5 2.5 3 3.5 5 3.5s3.5-1 5-3.5"/><circle cx="12" cy="13.5" r="5"/><circle cx="12" cy="13.5" r="1.4"/>',
    bangle: '<ellipse cx="12" cy="12" rx="8.5" ry="4.5"/><path d="M3.5 12v1.6c0 2.5 3.8 4.5 8.5 4.5s8.5-2 8.5-4.5V12"/>',
    pyramid: '<path d="M12 3.5l8.5 15h-17z"/><path d="M12 3.5v15M7.8 11h8.4"/><circle cx="12" cy="13.6" r="1.5"/>',
    set: '<circle cx="8" cy="9" r="4"/><circle cx="16" cy="9" r="4"/><circle cx="12" cy="15.5" r="4"/>',
    water: '<path d="M12 3.5c3.4 4.4 5.5 7.6 5.5 10.2a5.5 5.5 0 0 1-11 0c0-2.6 2.1-5.8 5.5-10.2z"/><path d="M9.2 14.2c.9.8 1.9.8 2.8 0s1.9-.8 2.8 0"/>',
    shield: '<path d="M12 3.5l7 2.7v5.4c0 4.4-3 7.6-7 8.9-4-1.3-7-4.5-7-8.9V6.2z"/><circle cx="12" cy="11.6" r="3"/>',
    antenna: '<path d="M12 3v18M8 21h8"/><path d="M12 6c2.4.8 2.4 2.2 0 3s-2.4 2.2 0 3 2.4 2.2 0 3"/><path d="M6.5 5.5a8 8 0 0 0 0 9M17.5 5.5a8 8 0 0 1 0 9"/>',
    commission: '<path d="M4 20l8.5-8.5"/><path d="M11 7.5l3-3 5.5 5.5-3 3z"/><path d="M14 13.5l2.5 2.5M3.5 20.5h6"/>',
    learn: '<path d="M3.5 6c3-1.2 5.8-1 8.5 1 2.7-2 5.5-2.2 8.5-1v12c-3-1.2-5.8-1-8.5 1-2.7-2-5.5-2.2-8.5-1z"/><path d="M12 7v12"/>',
    mentor: '<path d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12z"/><circle cx="12" cy="12" r="3"/><path d="M12 2v1.5M12 20.5V22"/>',
    watch: '<circle cx="12" cy="12" r="8.5"/><path d="M10 8.7v6.6l5.2-3.3z"/>',
    cart: '<path d="M5 8h14l-1.2 11.5H6.2z"/><path d="M9 8V6.5a3 3 0 0 1 6 0V8"/>',
    search: '<circle cx="10.5" cy="10.5" r="6"/><path d="M15 15l5 5"/>',
    account: '<circle cx="12" cy="8.5" r="3.8"/><path d="M4.5 20c1.4-3.6 4.2-5.3 7.5-5.3s6.1 1.7 7.5 5.3"/>',
    arrow: '<path d="M4 12h16M14 6l6 6-6 6"/>',
    menu: '<path d="M4 8h16M4 16h16"/>',
    close: '<path d="M6 6l12 12M18 6L6 18"/>',
    hand: '<path d="M8 12V5.5a1.5 1.5 0 0 1 3 0V11M11 10.5V4.5a1.5 1.5 0 0 1 3 0v6M14 10.5V6a1.5 1.5 0 0 1 3 0v7.5c0 4-2.6 7-6.2 7-2.4 0-4-1.2-5.4-3.4L3.6 13a1.5 1.5 0 0 1 2.5-1.6L8 13.5"/>',
    pin: '<path d="M12 21s-6.5-6.2-6.5-11a6.5 6.5 0 0 1 13 0c0 4.8-6.5 11-6.5 11z"/><circle cx="12" cy="10" r="2.3"/>',
    spark: '<path d="M12 3v5M12 16v5M3 12h5M16 12h5M6.3 6.3l2.8 2.8M14.9 14.9l2.8 2.8M17.7 6.3l-2.8 2.8M9.1 14.9l-2.8 2.8"/>'
  };

  // Cubits — names and frequencies exactly as the current store lists them; collection handles are live.
  const CUBITS = [
    { id: 'sacred', name: 'Sacred', freq: '144 MHz', a: 3, b: 4, h: 'sacred-cubit-1', note: 'The signature measure. Most of the Light Shop begins here: the cubit cut for clarity and protection.' },
    { id: 'lost', name: 'Lost', freq: '177 MHz', a: 5, b: 4, h: 'lost-cubit', note: 'A forgotten length, recovered. Grounding and steady, it carries the largest family of tools.' },
    { id: 'cosmic', name: 'Cosmic Connector', freq: '528 MHz', a: 5, b: 6, h: 'cosmic-connector', note: 'Tuned to 528. Chosen for heart coherence and connection.' },
    { id: 'earth', name: 'Earth Core', freq: '333 MHz', a: 1, b: 3, h: 'earth-core-cubit', note: 'The measure of the ground beneath you. Used in the Merkaba and thick-gauge harmonizers.' },
    { id: 'newearth', name: 'New Earth', freq: '432 Hz', a: 4, b: 3, h: 'new-earth-cubit-432', note: 'Set to 432 Hz, the natural tuning. A measure for the life you are building now.' },
    { id: 'atlantean', name: 'Atlantean', freq: 'Ancient', a: 2, b: 3, h: 'atlantean-cubit-1', note: 'An ancient continental measure, forged into bangles, harmonizers and water tools.' },
    { id: 'ramu', name: 'Ra-Mu', freq: 'Volcanic', a: 3, b: 5, h: 'ra-mu-cubit', note: 'Fire and the deep Earth. Often paired with quartz in the double-twist harmonizers.' },
    { id: 'empower', name: 'Empowerment', freq: 'Higher-D', a: 7, b: 6, h: 'empowerment-cubit', note: 'A higher-dimensional measure for will, purpose and forward motion.' }
  ];

  // Each cubit's sigil is a Lissajous figure: a visual signature of the field, unique per measure.
  function sigilPath(a, b, size = 100, phase = Math.PI / 2) {
    const r = size * 0.42, c = size / 2, pts = [];
    for (let i = 0; i <= 720; i++) {
      const t = (i / 720) * Math.PI * 2;
      pts.push(`${(c + r * Math.sin(a * t + phase)).toFixed(2)},${(c + r * Math.sin(b * t)).toFixed(2)}`);
    }
    return 'M' + pts.join('L');
  }
  function sigil(cubit, opts = {}) {
    const s = opts.size || 100;
    return `<svg viewBox="0 0 ${s} ${s}" fill="none" stroke="currentColor" aria-hidden="true" class="sigil">
      <circle cx="${s / 2}" cy="${s / 2}" r="${s * 0.47}" stroke-width="${opts.ring || 0.5}" opacity=".45"/>
      <path d="${sigilPath(cubit.a, cubit.b, s)}" stroke-width="${opts.stroke || 0.7}" stroke-linejoin="round"/>
    </svg>`;
  }

  function icon(name, cls = '') {
    return `<svg class="ic ${cls}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${I[name] || ''}</svg>`;
  }

  // Hydrate any [data-icon], [data-sigil] placeholders.
  function hydrate(root = document) {
    root.querySelectorAll('[data-icon]').forEach(el => { if (I[el.dataset.icon]) el.innerHTML = icon(el.dataset.icon); });
    root.querySelectorAll('[data-sigil]').forEach(el => {
      const c = CUBITS.find(x => x.id === el.dataset.sigil); if (c) el.innerHTML = sigil(c);
    });
  }

  window.MOONAS = { ICONS: I, CUBITS, icon, sigil, sigilPath, hydrate, NS };
  document.addEventListener('DOMContentLoaded', () => hydrate());
})();
